<template>
  <div class="tw-relative tw-h-full tw-w-full">
    <img
      class="tw-pointer-events-none tw-absolute tw-left-0 tw-top-1/2 tw-w-36 tw-min-w-36 tw-origin-left -tw-translate-y-1/2 tw-transition-all tw-duration-300"
      :class="{
        '-tw-translate-x-1/2 tw-opacity-0 tw-duration-100': collapsed,
        'tw-translate-x-0': !collapsed,
      }"
      src="/images/logo_no_tagline.svg"
    />
    <img
      class="tw-pointer-events-none tw-absolute tw-left-1/2 tw-top-1/2 tw-w-6 tw-min-w-6 tw-translate-y-[-50%] tw-transition-all"
      :class="{
        'tw-left-0 -tw-translate-x-1/2 tw-opacity-100 tw-delay-100 tw-duration-300':
          collapsed,
        'tw-left-full tw-translate-x-full tw-opacity-0': !collapsed,
      }"
      src="/images/logo_no_text.svg"
    />
  </div>
</template>

<script setup>
import { useMenuStore } from "store/modules/menuStore.js";
import { storeToRefs } from "pinia";

const menuStore = useMenuStore();
const { collapsed } = storeToRefs(menuStore);
</script>
